import { createContext } from "react";

export const BiomeShadowRootContext = createContext<ShadowRoot | undefined>(
  undefined,
);
